import React from "react";
import PropTypes from "prop-types";

export default function ConfirmationBanner({
  pendingAction,
  loading,
  onConfirm,
  onCancel
}) {
  if (!pendingAction) return null;

  return (
    <div className="copilot-confirm">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 20
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              color: "#A36A00",
              fontWeight: 700,
              marginBottom: 8
            }}
          >
            ⚠ Confirmation Required
          </div>

          <h3 style={{ marginTop: 0 }}>
            {pendingAction.label || "Confirm Action"}
          </h3>

          <p
            style={{
              margin: "10px 0",
              color: "#555",
              lineHeight: 1.6
            }}
          >
            {pendingAction.description ||
              "This action requires confirmation before it will be executed."}
          </p>

          <div
            style={{
              fontSize: 13,
              color: "#666"
            }}
          >
            No changes have been made yet.
          </div>
        </div>

        <div
          className="copilot-confirm-actions"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          <button
            className="copilot-btn-primary"
            disabled={loading}
            onClick={onConfirm}
          >
            {loading ? "Executing..." : "Confirm"}
          </button>

          <button
            className="copilot-btn-secondary"
            disabled={loading}
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

ConfirmationBanner.propTypes = {
  pendingAction: PropTypes.object,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

ConfirmationBanner.defaultProps = {
  pendingAction: null,
  loading: false
};